module.exports = __webpack_public_path__ + "static/media/polo.7b2898be.png";